"use strict";

require("core-js/modules/es.array.concat");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadState = loadState;

/**
 * @param app app ID, e.g. "mail"
 * @param key name of the property
 * @throws if the key can't be found
 */
function loadState(app, key) {
  var elem = document.querySelector("#initial-state-".concat(app, "-").concat(key));

  if (elem === null) {
    throw new Error("Could not find initial state ".concat(key, " of ").concat(app));
  }

  try {
    return JSON.parse(atob(elem.value));
  } catch (e) {
    throw new Error("Could not parse initial state ".concat(key, " of ").concat(app));
  }
}
//# sourceMappingURL=index.js.map